import ApiJobTime from 'types/api/JobTime';
import { Option } from 'types/options';

import Model from 'models/Model';

export default class JobTime implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiJobTime) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }

    getOption = (): Option<JobTime> => {
        return {
            value: this,
            label: this.name,
        };
    };
}
